import { UPDATE_PROFILE } from 'root/src/client/logic/profile/actionIds'

export default payload => ({
	type: UPDATE_PROFILE,
	payload,
})
